<div class="py-24">
  <div class="mb-4">
    <mat-icon style="width: 50px; height: 50px; font-size: 50px;">sentiment_very_dissatisfied</mat-icon>
  </div>
  <div class="text-lg leading-6">
    都合により、この問題はご覧になれません <br />
    申し訳ございません
  </div>
</div>
